export default __webpack_public_path__ + "static/media/gmb.4cf7bc6e.png";